import Index from "./router/router";
import './App.less';
import { ConfigProvider, theme } from "antd";

function App() {
  return (
    <div className="App">
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: "#1a74d2",
            colorLink: "#1a74d2",
            colorLinkActive: "#0c53ab",
            colorLinkHover: "#3e91de"
          }
        }}
      >
        <Index />
      </ConfigProvider>
    </div>
  );
}

export default App;
